import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// TS type
import { ITHSRInfoData, NotIncludeObj } from '@redux/common';
import { RootState } from '@redux/store';

// import module

// component
import MiniCalendar from '@Common/MiniCalendar';

// plugin
import dayjs from 'dayjs';

// common function
import { convertTicketNum, getCommonAbleDates, generateDates } from '@libs/core';
import { setGDSSessionData } from '@libs/apiCall';

// redux actions
import {
    setGTempCalendarData,
    setTicketNum,
    setCalendar,
    setTGCalenderErr,
    setTGSessionErr,
    setTGTicketErr,
    setIsTGDSSessionLoading,
    setTGDSSessionFetchFail,
    setSession,
    setSessionPicked,
    setTGFinalAbleDates,
    setTGSubmitErrMsg,
} from '@redux/GDST/actions';

interface IGCalendarProps {}
interface loopDates {
    (start: string, end: string): string[];
}
const TCalendarBlock: React.FC<IGCalendarProps> = (props) => {
    // console.log('CalendarBlock', props);
    const dispatch = useDispatch();
    const {
        TGNowListData,
        calendar,
        GDetail,
        TGCalenderErr,
        TGSessionErr,
        TGTicketErr,
        TGfinalAbleDates,
        TGSubmitErrMsg,
    } = useSelector((state: RootState) => state.GDST);
    const { FormatID, EndDate } = TGNowListData;
    const { LastBuyDay } = GDetail;
    const { ETID } = useSelector((state: RootState) => state.Common);
    const { THSRInfo } = useSelector((state: RootState) => state.THSR);
    const { ProductUseDate }: ITHSRInfoData = THSRInfo;

    const min: string = GDetail?.EarliestBuyDay || dayjs().format('YYYY-MM-DD'); // 如果沒有可賣日期將今天min && max設為當日再用disabled date扣掉今天
    // const max: string = EndDate || dayjs().format('YYYY-MM-DD'); // 如果沒有可賣日期將今天min && max設為當日再用disabled date扣掉今天
    const max: string = (() => {
        if (!LastBuyDay) return dayjs().format('YYYY-MM-DD');
        // 因為GDS月曆改成點下一步才會撈之後的日期，所以CalendarDate已無法當成依據
        // const keys = Object.keys(GDetail.CalendarDate || {});
        // dayjs.extend(minMax);
        // const formatKeys = keys.map((item) => {
        //     if (dayjs(item, 'YYYY-MM-DD').isValid()) return dayjs(item);
        // });
        // const lastAbledDate = dayjs.max(formatKeys);
        // 使用calendarDate最後一天當EndDate避免方案清單拿到的EndDate跟打方案明細後的的calendar最後一天不同
        // if (!lastAbledDate) return EndDate;
        // return lastAbledDate.format('YYYY-MM-DD');

        return LastBuyDay;

    })();
    const noAvailableDays = !GDetail?.EarliestBuyDay && !EndDate;
    const notIncludes = GDetail.NotIncludeDate;

    // 客製不可選日子陣列
    const disabledDates = ((dates: NotIncludeObj[], callback: loopDates) => {
        if (noAvailableDays) return [dayjs().format('YYYY-MM-DD')]; // 如果沒有可賣日期將今天設為disabled

        const allDisabled = [];

        // 備用 自己將0元也設進disabled
        // if (GDetail.CalendarDate) {
        //     const includeDate = Object.keys(GDetail.CalendarDate);
        //     if (includeDate.length !== 0) {
        //         includeDate?.map((item) => {
        //             if (GDetail.CalendarDate[item].LowestPrice === 0) {
        //                 allDisabled.push(item);
        //             }
        //         });
        //     }
        // }

        dates?.forEach((item: NotIncludeObj) => {
            if (!!item) {
                allDisabled.push(...callback(item.StartDate, item.EndDate));
            }
        });
        return allDisabled;
    })(notIncludes, generateDates);

    // 可選日子陣列
    const ableDates = ((oriDates: string[], disableDates: string[]) => {
        const sortDate = oriDates.filter(function (dates) {
            return this.indexOf(dates) < 0;
        }, disableDates);
        return sortDate;
    })(generateDates(min, max), disabledDates);

    // console.log("ableDates", ableDates);
    // console.log("ProductUseDate",ProductUseDate)

    // 高鐵限制使用日期與票券本身可使用日期比對重疊之日期作為最終可使用日期
    // 切換品項時，要重新render最終可使用日期
    const ableDatesByTHSRLimit = useMemo(() => getCommonAbleDates([ableDates, ProductUseDate]), [FormatID]);

    // console.log("ableDatesByTHSRLimit🤷‍♀️🤷‍♀️", ableDatesByTHSRLimit);
    // 設定最終篩選過後的可選日期並預選第一個日子，並重打一次session
    useEffect(() => {
        let newDate; // 最終篩選過後的第一個日子的session
        if (TGNowListData?.ExpectedUseDay) {
            dispatch(setTGFinalAbleDates(ableDatesByTHSRLimit));
            if (ableDatesByTHSRLimit[0] == null) {
                dispatch(setCalendar(null));
                newDate = null;
                return;
            }
            if (ableDatesByTHSRLimit[0] !== calendar) {
                dispatch(setCalendar(ableDatesByTHSRLimit[0]));
            }
            newDate = ableDatesByTHSRLimit[0];
        } else {
            dispatch(setTGFinalAbleDates(ProductUseDate));
            if (ProductUseDate[0] == null) {
                dispatch(setCalendar(null));
                newDate = null;
                return;
            }
            if (ProductUseDate[0] !== calendar) {
                dispatch(setCalendar(ProductUseDate[0]));
            }
            newDate = ProductUseDate[0];
        }
    
        GDetail.Sessions &&
        setGDSSessionData({
            date: newDate,
            FormatID,
            ETID,
            context: {
                setGSessionLoading: setIsTGDSSessionLoading,
                setGSessionFetchFail: setTGDSSessionFetchFail,
                setSession,
                setSessionPicked,
            },
            dispatch,
        });

    }, [ableDatesByTHSRLimit, TGNowListData]);

    //點選月曆
    const onClickDate = (date: string) => {
        
        const tickets = convertTicketNum(
            TGNowListData?.ExpectedUseDay
                ? GDetail.CalendarDate[date]?.ETItem
                : GDetail.ETItem
        );
        if(TGNowListData.ExpectedUseDay) dispatch(setGTempCalendarData(GDetail.CalendarDate));

        dispatch(setTicketNum(tickets));
        dispatch(setCalendar(date));
        
        GDetail.Sessions &&
            setGDSSessionData({
                date,
                FormatID,
                ETID,
                context: {
                    setGSessionLoading: setIsTGDSSessionLoading,
                    setGSessionFetchFail: setTGDSSessionFetchFail,
                    setSession,
                    setSessionPicked,
                },
                dispatch,
            });
        TGSessionErr && dispatch(setTGSessionErr(''));
        TGCalenderErr && dispatch(setTGCalenderErr(''));
        TGTicketErr && dispatch(setTGTicketErr(''));
        TGSubmitErrMsg && dispatch(setTGSubmitErrMsg(''));
    };

    const isMinAfterMax = dayjs(min).isAfter(max);
    // 如果最早日比最晚日還晚(因工作日規則會往後順延startDate卻不會順延EndDate)，將此特殊情況設日曆為null
    isMinAfterMax && dispatch(setCalendar(null));

    return (
        <MiniCalendar
            dates={TGNowListData?.ExpectedUseDay ? ableDatesByTHSRLimit : ProductUseDate}
            onClickDate={(date: string) => {
                onClickDate(date);
            }}
            defaultdate={calendar}
            forceSelect={true}
        />
    );
};

export default TCalendarBlock;